import { type DesignFileStates, designFileStates } from '@atlas/core-utils/work-order'
import type { AxisSelection } from '@atlas/types'
import { AxisCode, DeliverableType, FileType } from '@atlas/types'
import { useQuery } from '@tanstack/react-query'
import type { DeliverableFile } from '@/domain/work-order.types'
import { fileService } from '@/services/file.service'
import { useWithThumbnails } from './useThumbnails'
import { WORK_ORDER_FILES_KEY } from './useWorkOrderFiles'

/** Under the work-order-files family, so an upload or a delete on the order refreshes it too. */
export const designFilesKey = (orderCode: string) => [WORK_ORDER_FILES_KEY, orderCode, 'design']

const DESIGN_FILTERS: AxisSelection = {
	[AxisCode.FILE_TYPE]: [FileType.DELIVERABLE],
	[AxisCode.DELIVERABLE_TYPE]: [DeliverableType.FINAL_VISUAL],
}

/**
 * An order's design files, split into drafts, the active design and the files it replaced.
 *
 * Read through discovery rather than the detail aggregate, which lists active deliverables only.
 */
export function useDesignFiles(
	orderCode: string,
	enabled = true,
): DesignFileStates<DeliverableFile> & { isLoading: boolean } {
	const { data = [], isLoading } = useQuery({
		queryKey: designFilesKey(orderCode),
		queryFn: () => fileService.discover(DESIGN_FILTERS, { [AxisCode.ORDER_CODE]: [orderCode] } as AxisSelection),
		enabled,
	})
	return { ...designFileStates(useWithThumbnails(data)), isLoading }
}
